<div *ngIf="!initialData.isEdit" (click)="openInEditMode()" style="min-height: 1.25rem!important;">
    <p class="default-editor w-100" id="{{initialData.id+dynamicId}}" contenteditable="false"></p>
</div>

<div *ngIf="initialData.isEdit">

    <div id="container">
        <div class="countable-editor">
            <div class="d-flex flex-row flex-nowrap align-items-center w-100 ">
                <div class="border-gray2 border-end">
                    <button mat-button class="fontStyle bold button-small-icon-action" onclick="document.execCommand( 'bold',false,null);" title="Bold Highlighted Text">
                        <i class="fa-regular fa-b"></i>
                    </button>
                    <button mat-button class="fontStyle italic button-small-icon-action"
                        onclick="document.execCommand('italic',false,null);" title="Italicize Highlighted Text">
                        <i class="fa-regular fa-italic"></i>
                    </button>
                </div>
                <div class="border-gray2 border-end px-20">

                    <button mat-button class="fontStyle linespacing button-small-icon-action"
                        [matMenuTriggerFor]="lineSpacing" title="Line Height">
                        <i class="fa-regular fa-line-height"></i>
                        <i class="fa-regular fa-angle-down"></i>
                    </button>
                    <mat-menu #lineSpacing="matMenu" xPosition="before">
                        <button mat-menu-item *ngFor="let space of lineSpacingOptions"
                            [ngClass]="{'selected': selectedLineHeight == space }" (click)="changeLineSpacing(space)">
                            <span>{{ space }}</span>
                        </button>
                    </mat-menu>
                </div>
                <div class="border-gray2 border-end">
                    <button mat-button class="fontStyle unorderedlist button-small-icon-action"
                        onclick="document.execCommand('insertUnorderedList',false, null)" title="Unordered List">
                        <i class="fa-regular fa-list"></i>
                    </button>
                    <button mat-button class="fontStyle orderedlist button-small-icon-action"
                        onclick="document.execCommand('insertOrderedList', false, null);" title="Ordered List">
                        <i class="fa-regular fa-list-ol"></i>
                    </button>
                </div>
                <button mat-button class="fontStyle align-left button-small-icon-action"
                    onclick="document.execCommand( 'justifyLeft',false,null);" title="Align Left">
                    <i class="fa-regular fa-align-left"></i>
                </button>
                <button mat-button class="fontStyle align-center button-small-icon-action" onclick="document.execCommand( 'justifyCenter',false,null);" title="Align Center">
                    <i class="fa-regular fa-align-center"></i>
                </button>
                <button mat-button class="fontStyle align-right button-small-icon-action"
                    onclick="document.execCommand( 'justifyRight',false,null);" title="Align Right">
                    <i class="fa-regular fa-align-right"></i>
                </button>
                <button mat-button class="fontStyle align-center button-small-icon-action" onclick="document.execCommand( 'justifyFull',false,null);" title="Align Full Justify">
                    <i class="fa-regular fa-align-justify"></i>
                </button>
            </div>
            <button mat-button class="button-small-icon-action" (click)="deleteTextSection()" *ngIf="showDelete" title="Delete">
                <i class="fa-regular fa-trash-can"></i>
            </button>
        </div>
        <p class="default-editor w-100" id="{{initialData.id}}" contenteditable="true"
            placeholder="Copy your text or enter here" (paste)="onPaste($event)" (input)="emitContent($event)"></p>
    </div>
</div>
